module.exports = __webpack_public_path__ + "static/media/VocalSample.d2f7b662.mp3";